module.exports = __webpack_public_path__ + "static/screen-classic-laptop-6a2777b4c25220e6417884b1ef3b40f3.png";